import { FunnelIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export default function FamilleSearch({ search, setSearch }) {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="relative w-1/3">
        <MagnifyingGlassIcon className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" />
        <input
          type="text"
          placeholder="Rechercher une famille..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="pl-10 pr-4 py-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <button className="flex items-center gap-2 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-2 px-4 rounded-lg transition">
        <FunnelIcon className="w-5 h-5" />
        Filtrer
      </button>
    </div>
  );
}
